<template>
	<section>
		<!--Toolbar -->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <!--<el-button style='float:left;' size='small' icon="el-icon-check" @click.native="closeForm">{{lang.butReturn}}</el-button>-->
			<el-form :inline="true">        
				<el-form-item>
					<el-input v-model="searchFilter" placeholder="Search"  @change='startSearch'></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon='el-icon-search' size='small' v-on:click="startSearch">{{lang.butSearch}}</el-button>
					<el-button type="" size='small' v-on:click="searchFilter='';getRecords();">C</el-button>
				</el-form-item>
        
				<span style='float:right'>
  				<el-form-item>
	  				<el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">{{lang.butAdd}}</el-button>
		  		</el-form-item>
				</span>
			</el-form>
		</el-col>

		<!--Lijst-->
		<el-table :data="content" stripe highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column prop="code" label="Code" min-width="120" sortable></el-table-column>
      <el-table-column prop="name" label="Name" min-width="120" sortable></el-table-column>
      <el-table-column prop="country" label="Country" min-width="120" sortable></el-table-column>
      <!--
      <el-table-column prop="ineu" label="In EU" min-width="120" sortable>
				<template slot-scope="scope">
           <el-switch disabled :width='35' v-model="scope.row.ineu" active-color="#58a632" inactive-color="#ccc"></el-switch>
				</template>
      -->
      </el-table-column>


      <!--
			<el-table-column label="" width='70'>
				<template slot-scope="scope">
					<el-button type='info' size="small" xicon="el-icon-edit"  @click="OpenRelated(scope.row)">[==VERVOLG==]</el-button>
				</template>
      </el-table-column>
			-->

			<el-table-column label="" width="100" fixed='right'>

				<template slot-scope="scope">
					<el-button type='success' size="small" icon="el-icon-edit"  @click="handleEdit(scope.row)"></el-button>
					<el-button disabled type="danger" size="small" icon="el-icon-delete"  @click="handleDel(scope.row)"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- Toolbar -->
		
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev,pager,next,jumper,sizes" @current-change="selectPage" :total="mainTotal" style="float:right;"
                     :page-sizes="[10, 15, 25, 50, 100]" @size-change="selectPagesize" :page-size="pageSize"></el-pagination>
      <span style='font-size:80%;margin:9px;float:right'>{{mainTotal}} records found</span>
      </el-col>
    
		<!--Wijzig record -->
		<el-dialog :title="editTitle" :visible.sync="editFormVisible"
                   :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="editForm" label-width="125px" :rules="editFormRules" ref="editForm">
        <el-tabs type="card">
          <!-- -------------------------------------------------------------------------------------- -->
				  <el-tab-pane>
            <span slot='label'><i class='el-icon-date'></i> Supplier</span>
            <el-form-item label="Code : ">
              <el-input :disabled="this.editMode=='save'"  v-model="editForm['code']" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Name : ">
              <el-input :disabled="this.editMode=='save'" v-model="editForm['name']" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Country : ">
              <el-input v-model="editForm['country']" auto-complete="off"></el-input>
            </el-form-item>
            <!--
            <el-form-item label="In EU : ">
              <el-switch :width='35' v-model="editForm['ineu']" active-color="#58a632" inactive-color="#ccc"></el-switch>
            </el-form-item>
            -->
  				</el-tab-pane>
				</el-tabs>
			</el-form>

			<div slot="footer" class="dialog-footer">		  
				<el-button size='small' icon="el-icon-upload2"  @click.native="editFormVisible = false">{{lang.butCancel}}</el-button>
				<el-button size='small' type="primary" icon="el-icon-edit"  @click.native="editSubmit" :loading="editLoading">{{lang.butSave}}</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/bas/supplier';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"SUP"),
        util        : util,
        stack       : {},
			  lang        : text.data,
        codes       : util.codes,
				pageSize    : settings.pageSize,
 		  	serverPaging: false,
        stage       : window.stage,

				editTitle   : "",
				editMode    : "",
        userDepts   : "",
        userRoles   : "",
				APICode     : "BasSupplier",
				mainFunc    : "Supplier",
				mainSubject : "Supplier",
        mainKey     : "code",
				mainKeyDesc : "name",
        searchFilter: '',				
        content: [],
				counter: {},
				related: [],
				currentPage: 1,
				mainTotal: 0,
		
				listLoading: false,
				editFormVisible: false,// Of de bewerkingsinterface wordt weergegeven
				editLoading: false,
				editForm: {},			
				editFormRules: {
					code: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					]
				},

			}
		},
		
		methods: {
 	  	closeForm: function () {
         this.selectorVisible = false;
	  		this.$router.push({name: 'Employees',params: this.stack});
    	},


		  startSearch: function() {
        this.currentPage = 1;
        this.content = [];        
        this.getRecords();
      },
    // paginering wissel, reload page			
		  selectPagesize: function(size) {
				settings.pageSize = size;
				this.showPagedData();
			},
			selectPage: function(page) {
				this.currentPage = page;								
				this.showPagedData();
			},
			showPagedData: function() {
				if (this.serverPaging) this.getRecords();
				else this.content = this.contentSaved.slice((this.currentPage - 1) * 
				                    settings.pageSize,this.currentPage * settings.pageSize);
      },

			// Ophalen record(s) via API
			getRecords() {				
        let parg = {};
        parg.Params = {};
        parg.Params.search = this.searchFilter;
			
				this.listLoading = true;
				
				api.getListPage(parg).then((res) => {						
          util.processMainResults(res);
          this.codes = util.codes;          
          this.mainTotal = util.payload[this.APICode].length;         
         
          if (this.mainTotal > 0)
          {
            if (this.serverPaging)
           	  this.content = util.getMainPayload(this.APICode);
			  		else {
 				  		this.contentSaved = util.getMainPayload(this.APICode);
  				    if (this.contentSaved.length > 0)
    				    this.selectPage(1);
  					}
          }
					else {
            this.content = [];
            this.contentSaved = [];
          }
          this.listLoading = false;
				})
        .catch((error) => {
          util.serverError(this);
        });


			},
			

			openRelated: function(row) {       
			},

			// Verwijder
			handleDel: function (row) {
				this.$confirm(text.getText("sdelM",this.mainSubject,row[this.mainKeyDesc]), 'Confirm', {
					type: 'warning',title: text.getText("sdelT",this.mainSubject)
				}).then(() => {
					this.listLoading = true;

          let parg = {};
          parg["Action"] = "del";
          parg["Record"] = Object.assign({}, row);

				  api.removeRecord(parg).then((res) => {
						this.listLoading = false;
  					this.$notify({
	  				  title: text.data.conf,type: 'success',
		  				message: text.getText("delOK",this.mainSubject,row[this.mainKey])			  			              
				  	});
						this.getRecords();
					});

				}).catch(() => {

				});
			},
			
			// Display bewerkingsinterface
			handleEdit: function (row) {
        this.editMode = "save";
				this.editTitle = text.getText("modM",this.mainSubject,row[this.mainKey]);
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
        //this.$nextTick(() => this.$refs.firstEdit.focus());
			},
			
			// Toon nieuwe interface
			handleAdd: function () {
				this.editMode = "add";
				this.editTitle = text.getText("addM",this.mainSubject);
				this.editFormVisible = true;
				this.editForm = {};
        //this.$nextTick(() => this.$refs.firstAdd.focus());
			},

			// uitgeven
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
					  this.editLoading = true;
						
            let parg = {};
            parg["Record"] = Object.assign({}, this.editForm);

            if (this.editMode == "add") 
            {
						  parg["Action"] = "add";
            	api.addRecord(parg).then((res) => {
                util.processMainResults(res);
                if (util.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("addOK",this.mainSubject,this.editForm.name)});
                else this.$notify({title: "Error",type: 'error',message: util.header.message});
		    				this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
   			 	  		this.getRecords();
	  					});
            }
						else {
							parg["Action"] = "save";
              api.saveRecord(parg).then((res) => {		  					
                util.processMainResults(res);
                if (util.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("modOK",this.mainSubject,this.editForm.name)});
                else this.$notify({title: "Error",type: 'error',message: util.header.message});
						    this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
		    				this.getRecords();
	  					});
            }
					}
				});
			},

		},

		mounted() {
      
      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });

      this.userDepts = sessionStorage.getItem("depts");
      this.userRoles = sessionStorage.getItem("roles");


      if (this.$route.params) {
        this.stack = this.$route.params;
      }
      

			this.related = settings.getRelated();
			this.getRecords();
		}
	}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// supplier.vue?c5daed54